import { type IContent } from "@kunduz/data-access-cms-api";
import { useAppContext } from "@kunduz/feature-website-context";
import { MobileAccordionMenu, blue, green } from "@kunduz/ui-components";
import React, { ReactElement } from "react";
import { prepareCmsMenuItems } from "./cmsMenuItems";
import { trackEventNext } from "@kunduz/utility-analytics";

export const MobileTop = (props: Props): ReactElement => {
  const { profiles, logout, kunduzApiToken } = useAppContext();

  const iconColors = {
    student: blue[600],
    teacher: green[600],
    school: blue[600],
  };

  const handleLogoutClick = () => {
    logout().then(() => {
      window.location.reload();
    });
  };

  function handleClicked(label?: string) {
    trackEventNext({ event: "Navbar Button Clicked", label });
  }

  const menus = prepareCmsMenuItems(
    iconColors[props.headerType],
    props.mobileTopCmsData,
    handleClicked,
    kunduzApiToken,
  );

  return (
    <MobileAccordionMenu
      menus={[
        ...menus,
        ...(profiles
          ? [
              {
                title: "Çıkış",
                onClick: handleLogoutClick,
                variant: "destructive" as any,
              },
            ]
          : []),
      ]}
    />
  );
};

interface Props {
  headerType: "student" | "teacher" | "school";
  mobileTopCmsData?: IContent.HeaderItemsResponse["components"];
  lang: "tr" | "en";
}
